import type { JSX } from 'react';
import React from 'react';

import Button from '@/ui/components/Button/Button';

import { BillingReportRow } from '../types';
import type { ServiceLine } from '../types/service_line';
import { currencyFormatter } from '../utils/currencyFormatter';

import BillingReportLineItem from './BillingReportLineItem';
import OverLabel from './OverLabel';

const ServiceLineItem = ({
  handleLinkButtonPress,
  linkedBillingReportRows = [],
  row,
  selectedBillingItems,
  showLinkButton
}: {
  handleLinkButtonPress: (row: ServiceLine) => void;
  linkedBillingReportRows: BillingReportRow[];
  row: ServiceLine;
  selectedBillingItems: BillingReportRow[];
  showLinkButton: boolean;
}): JSX.Element => {
  return (
    <div key={row.id} className={`mb-2 p-1 bg-white rounded shadow border`}>
      <div className="grid grid-cols-12 min-w-0 gap-x-4 items-center ">
        {showLinkButton && (
          <div className="col-span-3">
            <Button
              color="green"
              onClick={() => handleLinkButtonPress(row)}
              disabled={selectedBillingItems.length <= 0}>
              Associate Selected Items
            </Button>
          </div>
        )}
        <div className="flex-grow grid grid-cols-5 gap-x-2 py-2 px-4 col-span-8 ">
          <OverLabel label="Date">{row.serviceDate?.toISOString()?.split('T')[0]}</OverLabel>

          <OverLabel label="CPT Code">{row.cptCodeCode || '-'}</OverLabel>

          <OverLabel label="Modifiers">
            {[row.mod1, row.mod2, row.mod3, row.mod4].filter((mod) => mod).join(', ') || '-'}
          </OverLabel>

          <OverLabel label="Units">{row.units}</OverLabel>

          <OverLabel label="Fee">
            {row.feeInCents ? currencyFormatter(row.feeInCents / 100) : ''}
          </OverLabel>
        </div>
      </div>

      {linkedBillingReportRows && linkedBillingReportRows.length > 0 && (
        <>
          <hr className="my-4" />
          <div className="grid grid-cols-12 min-w-0 gap-x-4 items-center ">
            <div className="py-3 justify-start items-start gap-2 flex col-span-3">
              <div className="w-64 text-black text-base font-semibold">Associated Line-items:</div>
            </div>
            <div className="col-span-8">
              {linkedBillingReportRows.map((row) => (
                <BillingReportLineItem key={row.service_id} row={row} />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ServiceLineItem;
